//export const baseUrl = "http://192.168.1.40:8000";
//export const baseUrl = "http://192.168.1.104:8000";
//export const baseUrl = "https://apiuat.dbiexchange.com";
const server = "live";
export const baseUrl = process.env.REACT_APP_baseUrl
//(server == "live") ? "https://api.dbiexchange.com" : "https://apiuat.dbiexchange.com";

